import { Typography } from "@mui/material";

export default function Home() {
  return (
    <div style={{ padding: 20 }}>
      <Typography variant="h4">Family MDM Admin</Typography>
      <Typography>Welcome to your dashboard.</Typography>
    </div>
  );
}

